/**
 * Fetch the list of flaws and (flaw)locations from reware-api
 *
 * @param {Object} args The structured arguments for the function
 * @param {string} args.partnerUuid - the partner's uuid
 * @param {string} args.rubricCode - comes from the catalog_item data
 * @param {string} args.category - comes from the catalog_item data
 * @returns {Object} An object with two attributes: a list of flaws
 * and a list of locations.  The flaws object has the following shape:
 * { id, name, imageUrl }.  The locations object has the following shape:
 * { id, name }.
 */
async function fetchItemFlawsAndLocations({
  partnerUuid,
  rubricCode,
  category,
}) {
  const query = `
    query itemFlawsAndLocations(
      $partnerUuid: String!
      $rubricCode: String
      $category: String
    ){
      itemFlawsAndLocations (
        partnerUuid: $partnerUuid
        rubricCode: $rubricCode
        category: $category
      ){
        count
        mostCommonLocations {
          id
          name
        }
        mostCommonProblems {
          id
          name
        }
        rows {
          id
          attributeGroupCode
          name
        }
      }
    }
  `;
  const param = 'query-itemFlawsAndLocationsFetch';
  const FLAWS_TO_SHOW = 5;

  try {
    const response = await fetchWithAppName(`${global.url}${param}`, {
      body: JSON.stringify({ query, variables: { partnerUuid, category, rubricCode } }),
    });
    const jsonData = await response.json();
    const { mostCommonProblems, mostCommonLocations } = jsonData.data.itemFlawsAndLocations;
    const sharedAttributeRows = jsonData.data.itemFlawsAndLocations.rows;

    const flaws = mostCommonProblems.length > 0 ? mostCommonProblems :
      sharedAttributeRows
        .filter(elem => elem.attributeGroupCode === 'ii_problem_attribute')
        .slice(0, FLAWS_TO_SHOW);

    const locations = mostCommonLocations.length > 0 ? mostCommonLocations :
      sharedAttributeRows
        .filter(elem => elem.attributeGroupCode === 'ii_location_attribute')
        .slice(0, FLAWS_TO_SHOW);

    return { flaws, locations };
  } catch (e) {
    console.log(e);
  }
}

/* ---- DOM manipulation ---- */
const currentTradeinItem = JSON.parse(sessionStorage.getItem("currentTradeinItem"));
const tradeinPromoDetails = JSON.parse(sessionStorage.getItem("tradeinPromoDetails"));

if (!currentTradeinItem) {
  window.location = `${Shopify.routes.root}pages/trade-in-search-2`;
}
const tradeinConditionGradingWrapper = document.querySelector('.trade-in-condition-grading');
const content = document.querySelector('.trade-in-condition-grading__content');
const itemName = document.getElementById('trade-in-condition-grading__item-name');
const itemBrand = document.getElementById('trade-in-condition-grading__item-brand-name');
const itemStyleNumber = document.getElementById('trade-in-condition-grading__item-style-number');
const itemImageDesktop = document.getElementById('trade-in-condition-grading__item-image__desktop');
const itemImageMobile = document.getElementById('trade-in-condition-grading__item-image__mobile');
const itemImageWrapper = document.querySelector('.trade-in-condition-grading__image-thumbnail-wrapper');
const sliderComponent = document.querySelector('.slider');
const sliderLeft = document.querySelector('.slider-button--prev');
const sliderRight = document.querySelector('.slider-button--next');
const sliderCount = document.querySelector('.slider-counter--current');
const confirmButton = document.getElementById('trade-in-condition-grading__confirm-button');
const yesOption = document.getElementById('trade-in-condition-grading__yes_option');
const noOption = document.getElementById('trade-in-condition-grading__no_option');
const conditionGradingDrawer = document.querySelector('condition-grading-drawer');
const estimatedValue = document.getElementById('trade-in-condition-grading__estimated-value');
const estimatedPrepromoValue = document.getElementById('trade-in-condition-grading__estimated-prepromo-value');
const promotionText = document.querySelector('.trade-in-condition-grading__promotion-text');
const estimatedValueLabel = document.getElementById('trade-in-condition-grading__estimated-value-label');
const modalTermsAndConditionsContent = document.querySelector('.modal-terms-and-conditions__content');

confirmButton.disabled = true;

if (currentTradeinItem.tradeinValue !== currentTradeinItem.displayTradeinValue) {
  estimatedPrepromoValue.textContent = formatCurrency(currentTradeinItem.displayTradeinValue);
  estimatedPrepromoValue.classList.remove('hidden');
  promotionText.classList.remove('hidden');
  estimatedValueLabel.firstElementChild.style.setProperty('font-weight', '600', 'important');
}
estimatedValue.textContent = formatCurrency(currentTradeinItem.tradeinValue);

itemName.textContent = currentTradeinItem.catalogItemTitle || (
  `${currentTradeinItem.departmentDisplay} ${currentTradeinItem.categoryDisplay}`
);
itemStyleNumber.textContent = currentTradeinItem.isUnknown ?
  '' :
  `${TRADE_IN_CONDITION_GRADING_CONFIG.styleNoLabel} ${currentTradeinItem.parentSku}`;

if (itemBrand) {
  itemBrand.textContent = currentTradeinItem.catalogItemBrand || '';
}

const imageUrls = currentTradeinItem.images?.map(image => image.url);
if (currentTradeinItem.itemImageUrl) {
  itemImageDesktop.src = currentTradeinItem.itemImageUrl;
  itemImageMobile.src = currentTradeinItem.itemImageUrl;
  imageUrls?.forEach((imageUrl, i) => {
    if (i !== 0) {
      const itemImageThumbnail = document.createElement('img');
      itemImageThumbnail.src = imageUrl;
      itemImageWrapper.appendChild(itemImageThumbnail);
    }
  });
} else {
  itemImageDesktop.src = localStorage.getItem('cameraShyImageUrl');
  itemImageMobile.src = localStorage.getItem('cameraShyImageUrl');
  imageUrls?.forEach((_, i) => {
    if (i !== 0) {
      const itemImageThumbnail = document.createElement('img');
      itemImageThumbnail.src = localStorage.getItem('cameraShyImageUrl');
      itemImageWrapper.appendChild(itemImageThumbnail);
    }
  });
}
if (currentTradeinItem.isUnknown) {
  sliderComponent.classList.add('hidden');
  itemImageMobile.classList.add('hidden');
  itemImageDesktop.classList.add('hidden');
  tradeinConditionGradingWrapper.classList.add('trade-in-condition-grading-unknown');
  content.firstElementChild.style.display = "none";
  content.lastElementChild.style.width = "100%";
} else if (imageUrls?.length === 1) {
  sliderComponent.classList.add('hidden');
} else {
  itemImageMobile.classList.add('hidden');
}

let imageIndex = 1;
const imageToDisplay = document.getElementById('Slide-1').querySelector('img');
if (imageUrls) {
  imageToDisplay.setAttribute('src', normalizeUrl(imageUrls[imageIndex], { width: '300', height: '300' }));
  const imageTotal = document.querySelector('.slider-counter--total');
  imageTotal.textContent = imageUrls.length - 1;
  sliderLeft.setAttribute('disabled', true);
}

let flaws;
let flawLocations;
const checkedFlawIds = new Set();
let isOpeningConditionGradingDrawer = false;

localStorage.removeItem('locations');
localStorage.removeItem('severities');

if (tradeinPromoDetails) {
  modalTermsAndConditionsContent.textContent = tradeinPromoDetails.tradeinPromoDetails?.termsAndConditions;
}

/* ---- Functions ---- */
async function submitTradeinFlawSelection () {
  if (TRADE_IN_CONDITION_GRADING_CONFIG.isTradeInMoreQuestionsEnabled) {
    window.location = `${Shopify.routes.root}pages/trade-in-more-questions`;
    return;
  }

  await addItemAndRedirectToCart();
};

async function renderFlawList() {
  checkedFlawIds.clear();
  const result = await fetchItemFlawsAndLocations({
    partnerUuid: global.partnerUuid,
    category: currentTradeinItem.category,
    rubricCode: currentTradeinItem.rubricCode,
  });

  flaws = result.flaws || [];
  flaws.push({
    id: null,
    name: TRADE_IN_CONDITION_GRADING_CONFIG.flawOtherText || 'Other',
  });

  flawLocations = result.locations;
  flawLocations.push({
    id: null,
    name: TRADE_IN_CONDITION_GRADING_CONFIG.flawOtherText || 'Other',
  });
  const flawEl = document.querySelector('.trade-in-flaw-selecton__flaw-list');
  flawEl.querySelector('.product-popup-modal__state').innerHTML = '';
  const flawElements = flaws?.map((flaw, i) => {
    const thisFlawEl = i === 0 ? flawEl : flawEl.cloneNode(true);
    const editButton = thisFlawEl.querySelector('button.product-popup-modal-edit__button');
    thisFlawEl.querySelector('modal-opener').setAttribute('data-modal', `#modal-flaw-${flaw.id}`);
    thisFlawEl.querySelector('.modal-open-button').setAttribute('id', `ConditionGrading-flaw-${flaw.id}`);
    thisFlawEl.querySelector('.product-popup-modal__state').setAttribute('id', `ConditionGrading-flaw-state-${flaw.id}`);
    editButton.setAttribute('id', `ConditionGrading-flaw-icon-${flaw.id}`);
    editButton.classList.add('hidden');
    thisFlawEl.querySelector('.flaw-name').textContent = flaw.name;
    return thisFlawEl;
  });

  flawEl.parentNode.replaceChildren(...flawElements);
  flawEl.parentNode.classList.remove('hidden');
  const flawHeader = document.querySelector('.trade-in-condition-grading__selectflaw-title');
  flawHeader.classList.remove('hidden');

  flaws.forEach(flaw => {
    const checkbox = checkboxForFlaw(flaw);
    checkbox.checked = false;

    const editButton = editButtonForFlaw(flaw);
    editButton.addEventListener('click', () => {
      handleClickFlawCheckbox({
        rubricCode: currentTradeinItem.rubricCode,
        flaw,
        flawLocations,
      });
    });
    checkbox.addEventListener('change', () => {
      if (checkbox.checked) {
        // Forbid checking checkboxes while we're opening the condition grading drawer. Otherwise, if
        // the drawer is a little slow to open and the user is checking a lot of checkboxes quickly,
        // you can get into weird states where the drawer opens but the user has already checked a
        // different flaw type.
        if (isOpeningConditionGradingDrawer) {
          checkbox.checked = false;
          return;
        }
        checkedFlawIds.add(flaw.id);
        handleClickFlawCheckbox({
          rubricCode: currentTradeinItem.rubricCode,
          flaw,
          flawLocations,
          checkbox
        });
        checkbox.classList.add('trade-in-condition-grading__selectflaw-checkbox');
        // DON'T show the edit button here. We intentionally wait to hear that the condition grading
        // drawer was closed, that way if the drawer never fully opens (e.g. due to missing images),
        // then we never show the edit button at all.
        enableOrDisableConfirmButtonByCountingFlaws();
      } else {
        checkedFlawIds.delete(flaw.id);
        checkbox.classList.remove('trade-in-condition-grading__selectflaw-checkbox');
        editButton.classList.add('hidden');
        handleUncheckedFlaw(flaw.id);
        enableOrDisableConfirmButtonByCountingFlaws();
      }
    });
  });
};

function checkboxForFlaw(flaw) {
  return document.getElementById(`ConditionGrading-flaw-${flaw.id}`);
}

function editButtonForFlaw(flaw) {
  return document.getElementById(`ConditionGrading-flaw-icon-${flaw.id}`);
}

function enableOrDisableConfirmButtonByCountingFlaws() {
  confirmButton.disabled = checkedFlawIds.size === 0;
}

function handleConditionGradingDrawerClosed(flaw) {
  const savedSeverity = JSON.parse(localStorage.getItem('severities'))
    ?.find((severity) => severity.flawId === flaw.id);
  const savedLocation = JSON.parse(localStorage.getItem('locations'))
    ?.find((location) => location.flawId === flaw.id);

  const checkbox = checkboxForFlaw(flaw);
  const editButton = editButtonForFlaw(flaw);

  if (savedSeverity && savedLocation) {
    const flawDetailEl = document.getElementById(`ConditionGrading-flaw-state-${flaw.id}`);
    flawDetailEl.textContent = `${savedSeverity.name} / ${savedLocation.name}`;
    flawDetailEl.classList.remove('hidden');
    checkedFlawIds.add(flaw.id);
    // Show the edit button now that we've confirmed that flaw details were actually added.
    editButton.classList.remove('hidden');
    // The checkbox for this flaw SHOULD already be checked, b/c that's how the drawer was opened
    // in the first place. But if the user double-clicks the checkbox quickly we can wind up in a
    // state where the drawer shows even while the checkbox is unchecked. If the user finished the
    // drawer and saved a flaw, we should make sure the checkbox matches that.
    checkbox.checked = true;
  } else {
    checkedFlawIds.delete(flaw.id);
    editButton.classList.add('hidden');
    checkbox.checked = false;
  }

  // Return focus back to where it was before we opened the condition grading drawer. Otherwise, in
  // the success case focus winds up below the list of flaws, making it hard to enter more flaws
  // using keyboard nav.
  checkbox.focus();
  enableOrDisableConfirmButtonByCountingFlaws();
}

async function handleUncheckedFlaw(flawId) {
  removeFlawFromLocalStorage(flawId);
  hideFlawDetails(flawId);
  await conditionGradingDrawer.updateMainPageOnSave();
}

function removeFlawFromLocalStorage(flawId) {
  removeLocationFromLocalStorage(flawId);
  removeSeverityFromLocalStorage(flawId);
}

function removeLocationFromLocalStorage(flawId) {
  let currentLocations = JSON.parse(localStorage.getItem('locations')) ?? [];

  const locationsUpdated = currentLocations.filter((location) => location.flawId !== flawId);

  localStorage.setItem('locations', JSON.stringify(locationsUpdated));
}

function removeSeverityFromLocalStorage(flawId) {
  let currentSeverities = JSON.parse(localStorage.getItem('severities')) ?? [];

  const severitiesUpdated = currentSeverities.filter((severity) => severity.flawId !== flawId);

  localStorage.setItem('severities', JSON.stringify(severitiesUpdated));
}

function hideFlawDetails(flawId) {
  const flawDetail = document.querySelector(`#ConditionGrading-flaw-state-${flawId}`);
  flawDetail.classList.add('hidden');
  flawDetail.textContent = '';
}

function hideFlawList() {
  const flawHeader = document.querySelector('.trade-in-condition-grading__selectflaw-title');
  flawHeader.classList.add('hidden');
  const flawEl = document.querySelector('.trade-in-flaw-selecton__flaw-list');
  flawEl.parentNode.classList.add('hidden');
}

async function selectOption(option) {
  if (option === 'yesOption') {
   confirmButton.disabled = true;
   await renderFlawList();
  } else if (option === 'noOption') {
    confirmButton.disabled = false;
    hideFlawList();
  }
};

function selectImage(option) {
  if (option === 'prev') {
    imageIndex--;
    imageToDisplay.setAttribute('src', normalizeUrl(imageUrls[imageIndex], { width: '300', height: '300' }));
    sliderRight.removeAttribute('disabled');
    if (imageIndex === 1) {
      sliderLeft.setAttribute('disabled', true);
    }
  } else {  //option === 'next'
    imageIndex++;
    imageToDisplay.setAttribute('src', normalizeUrl(imageUrls[imageIndex], { width: '300', height: '300' }));
    sliderLeft.removeAttribute('disabled');
    if (imageIndex === imageUrls.length - 1) {
      sliderRight.setAttribute('disabled', true);
    }
  }
  sliderCount.textContent = imageIndex;
}

async function handleClickFlawCheckbox ({
  rubricCode,
  flaw,
  flawLocations,
}) {
  isOpeningConditionGradingDrawer = true;
  try {
    await conditionGradingDrawer.tryOpen({
      rubricCode,
      flaw,
      flawLocations,
      onClose: () => handleConditionGradingDrawerClosed(flaw),
    });
  } finally {
    isOpeningConditionGradingDrawer = false;
  }
}

/* ---- Event Listeners ---- */
sliderLeft.addEventListener('click', () => selectImage('prev'));
sliderRight.addEventListener('click', () => selectImage('next'))
confirmButton.addEventListener('click', submitTradeinFlawSelection);
yesOption.addEventListener('click', () => selectOption('yesOption'));
noOption.addEventListener('click', () => selectOption('noOption'));
